import Vehicles from './Vehicles';

// Same page, forms, and components as Permanent Motor Vehicles — the backend
// keeps the two data sets separate via the vehicle's `category` field.
const TemporaryVehicles = () => <Vehicles category="temporary" />;

export default TemporaryVehicles;
